import { render, staticRenderFns } from "./BigTableModal.vue?vue&type=template&id=1d446e27&scoped=true&"
import script from "./BigTableModal.vue?vue&type=script&lang=js&"
export * from "./BigTableModal.vue?vue&type=script&lang=js&"
import style0 from "./BigTableModal.vue?vue&type=style&index=0&id=1d446e27&lang=scss&scoped=true&"
import style1 from "./BigTableModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d446e27",
  null
  
)

export default component.exports